// src/tenantAdmin/components/ActiveCompanyGuard.jsx
//
// The gate of the Crediti and Piani tabs. Both act on the ACTIVE workspace (the
// billing API and the credits API key every call on it, and the Stripe round trips
// are keyed on it too), while the console acts on the company its own selector
// chose. They coincide in the normal case; when they do not, showing the tab would
// print one company's wallet or plans under another company's name. So the content
// renders ONLY when the console's company IS the active workspace's company.
// ⚠️ "Not resolved yet" is its own state: activeCompanyId is null while the read
// is in flight, and reading that as "another company" would flash the message.
// The loading branch also covers a missing Outlet context. The mismatch card links
// to /select-tenant because the header carries no workspace switcher. Mounted
// INSIDE RequireCustomerAdmin in the route tree.
// Option B (true company scoping) is deliberately deferred — see the v181 plan.
import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COLORS, FONT_SANS, FONT_DISPLAY, RADII, SHADOW } from '../../constants/theme.js';

export default function ActiveCompanyGuard({ children }) {
  const { t } = useTranslation('admin');
  const company = useOutletContext()?.company;
  const companyId = company?.companyId || null;

  if (!company?.activeCompanyResolved) {
    return (
      <div role="status" style={{ padding: '32px 40px', fontFamily: FONT_SANS, color: COLORS.textSecondary, fontSize: '13px' }}>
        {t('manage.activeCompany.loading')}
      </div>
    );
  }
  if (companyId && company.activeCompanyId === companyId) return children;

  const name = company?.company?.legal_name;
  return (
    <div style={{ padding: '32px 40px', fontFamily: FONT_SANS, color: COLORS.ink, maxWidth: '1280px', margin: '0 auto' }}>
      <div style={{
        background: COLORS.surface, border: `1px solid ${COLORS.border}`,
        borderRadius: RADII.section, boxShadow: SHADOW.card, padding: '24px',
      }}>
        <h2 style={{ margin: 0, fontFamily: FONT_DISPLAY, fontSize: '16px', fontWeight: 700, lineHeight: '24px' }}>
          {t('manage.activeCompany.title')}
        </h2>
        <p style={{ fontSize: '13px', color: COLORS.textSecondary, margin: '8px 0 16px' }}>
          {name ? t('manage.activeCompany.body', { company: name }) : t('manage.activeCompany.bodyNoCompany')}
        </p>
        <Link to="/select-tenant" style={{ fontSize: '13px', fontWeight: 700, color: COLORS.accent }}>
          {t('manage.activeCompany.switch')}
        </Link>
      </div>
    </div>
  );
}
